/**
 * The properties the shared workspace event contract puts on its rows
 * (altimate-code-analytics `docs/workspace-event-contract.md`): `client` on
 * every row and the backend `workspace_id` on every workspace-scoped one.
 * Only contract rows use these; other events keep their own shapes.
 */

export const CLIENT = "web" as const;

/** The backend id as a number when it is one, else as given; absent when unknown. */
export const workspaceIdProp = (
  id: string | number | null | undefined
): number | string | undefined => {
  if (id === null || id === undefined || id === "") return undefined;
  const asNumber = Number(id);
  return Number.isInteger(asNumber) && asNumber > 0 ? asNumber : id;
};

/** `client`, plus `workspace_id` when the row has a workspace. */
export const contractProps = (
  workspaceId?: string | number | null
): { client: typeof CLIENT; workspace_id?: number | string } => {
  const workspace_id = workspaceIdProp(workspaceId);
  return workspace_id === undefined ? { client: CLIENT } : { client: CLIENT, workspace_id };
};
